export const PADDING_LEFT = 4;
export const LABEL_WIDTH = 280;
export const COLUMN_WIDTH = 80;
